import additionalNavigationBlocks from '@/vue/components/editorial/additionalNavigationBlocks'
import navigationBlocks from '@/vue/components/common/navigationBlocks'
export default {
  components: {
    'additional-navigation-blocks': additionalNavigationBlocks,
    'navigation-blocks': navigationBlocks
  },
  props: {
    navigationBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    additionalNavigatablePages: {
      type: Array,
      default () {
        return []
      }
    },
    navigationHeading: {
      type: String,
      default: ""
    }
  },
  computed: {
    allNavigatablePages () {
      return this.navigationBlocks.concat(this.additionalNavigatablePages)
    }
  }
}
